import type { CreateUserInput, UpdateUserInput } from '@idc-forms/schemas'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import {
  createUser,
  deleteUser,
  resetUserPassword,
  updateUser
} from '../services/users-admin.service'

export const useCreateUserMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: CreateUserInput) => await createUser(payload),
    onSuccess: () => {
      toast.success('Usuario creado — la contraseña inicial se envió a su correo')
      void queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useUpdateUserMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateUserInput }) =>
      await updateUser(id, payload),
    onSuccess: () => {
      toast.success('Usuario actualizado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useResetUserPasswordMutation = () => {
  return useMutation({
    mutationFn: async (id: string) => await resetUserPassword(id),
    onSuccess: (result) => {
      toast.success(`Nueva contraseña enviada a ${result.email}`)
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useDeleteUserMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => await deleteUser(id),
    onSuccess: () => {
      toast.success('Usuario eliminado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}
